import * as React from "react";

/**
 * Internal dependencies.
 */
import EdgeIcon from '§/src/images/svg/edge-right.svg';
import './_button-edge-rounded.scss';


const ButtonEdgeRounded = ( props ) => {

  // set atom class
  const atomClassName = 'button-edge-rounded rounded-circle';
  var atomClass = props.className != undefined ? atomClassName + ' ' + props.className : atomClassName;

  return (
    <i { ...props } className={ atomClass }>
      <EdgeIcon></EdgeIcon>
    </i>
  )
}

export default ButtonEdgeRounded
